import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <div class="poem">

      <p class="poem-block refreno mb-3">
        <span class="italic bold">Rf:</span> <br/>
        Aĉetu kringojn vi, <br/>
        Ah, ringan kringon-ĉi, <br/>
        Moneron donu vi <br/>
        Al povra in’. <br/>
        En tiu nokta hor’ <br/>
        Mi staras en angor’. <br/>
        Kompatu min kun plor’, <br/>
        Privatulin’.
      </p>

      <p class="poem-block mb-3">
        Mi staras ĉe angul’ <br/>
        Kun bluo sub okul’, <br/>
        Kaj revas sen skrupul’ <br/>
        Pri klientar’. <br/>
        Pro frosto tremas mi, <br/>
        Pri l’ sorto ĝemas mi, <br/>
        Aĉetu kringon vi <br/>
        Kontraŭ dolar’!
      </p>
      
      <p class="poem-block refreno mb-3">
        <span class="italic bold">Rf.</span>
      </p>

      <p class="poem-block mb-3">
        La patro batis min, <br/>
        Drinkadis li sen fin’, <br/>
        Kaj estas la patrin’ <br/>
        Purigistin’. <br/>
        Fratino sen moral’ <br/>
        Diboĉas kun skandal’ <br/>
        Kaj iĝis kriminal’ <br/>
        Fratet’-vandal’.
      </p>
      
      <p class="poem-block refreno mb-3">
        <span class="italic bold">Rf.</span>
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Kringetoj (huligana kanto)'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemVideo: ['HeRnVyHan0U'],
    itemTranslator: `
      Teksto: Ja. Jadov, <br/>
      Muziko: G. Krasavin, <br/>
      ${translator.esp}
    `
  }
}

export default item;